import NotFound from '../components/404/NotFound';

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
